// 用户信息管理
<template>
    <div class="group">
        <el-row>
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-edit"></i>
                        <span>用户信息管理</span>
                    </div>
                    <div class="search-content mar_b">
                        <el-form :inline="true" label-width="180px" size="mini" :model="getDataForm" class="demo-form-inline" ref="getDataForm">
                            <el-form-item prop="um" label="用户名：">
                                <el-input placeholder="请输入内容" v-model="getDataForm.username"></el-input>
                            </el-form-item>
                            <el-form-item prop="dp" label="部门：">
                                <el-input placeholder="请输入内容" v-model="getDataForm.department"></el-input>
                            </el-form-item>
                            <el-form-item class="search-but" style="float:right">
                                <el-button type="primary" @click="getUserInfoAllList">查询</el-button>
                                <el-button type="success" @click="dialogTableVisible = true" style="margin-right:400px">新增</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="text e-info auto-table">
                        <el-dialog title="编辑用户" :visible.sync = "dialogTableVisible" @close="closeSava">
                            <el-form :inline="true" label-width="180px" size="mini" :model="addDataForm" class="demo-form-inline" ref="addDataForm">
                                <el-form-item prop="userName" label="用户名：">
                                    <el-input style="width:300px;" v-model="addDataForm.userName" placeholder="请输入" readonly></el-input>
                                </el-form-item><br>
                                <el-form-item prop="department" label="部门：">
                                    <el-input style="width:300px;" v-model="addDataForm.department" placeholder="请输入"></el-input>
                                </el-form-item><br>
                                <el-form-item prop="mobile" label="手机号：">
                                    <el-input style="width:300px;" v-model="addDataForm.mobile" placeholder="请输入"></el-input>
                                </el-form-item><br>
                                <el-form-item class="search-but" style="margin-left:400px">
                                    <el-button type="primary" @click="savaDataParams">保存选择</el-button>
                                </el-form-item>
                            </el-form>
                        </el-dialog>
                    </div>
                    <div class="text e-info auto-table">
                        <el-table :data="userInfoAllList" border style="width: 100%;overflow-x: auto;">
                            <el-table-column type="selection" align="center" width="55"></el-table-column>
                            <el-table-column align="center" width="150" prop="userName" label="用户名" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="300" prop="department" label="部门" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="200" prop="mobile" label="手机号" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="200" prop="email" label="电子邮箱" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="100" label="状态" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.enabled==1">启用</span>
                                    <span v-if="scope.row.enabled==0">禁用</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" width="400" prop="caozuo" label="操作" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                    @click="updateModelDataParams(scope.row)">编辑</el-button>
                                    <el-button type="success" size="mini"
                                    @click="modifyUser(scope.row.id)">启用</el-button>
                                    <el-button type="info" size="mini"
                                    @click="deleteUser(scope.row.id)">禁用</el-button>
                                    <el-button type="warning" size="mini"
                                    @click="resetPassword(scope.row.id)">密码重置</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!--分页-->
                    <div class="block tar mar_t">
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[5, 10, 20]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    const Base64 = require('js-base64').Base64;
    const cityOptions = ['逾期风险', '企业负面舆情', '财务风险', '涉诉与行政处罚', '企业主信用风险', '关联风险', '行业与地域风险', '工商变更'];
    export default {
        data() {
            return {
                options: [{}],
                param_type: '',
                // 我的申请列表
                userInfoAllList: [],
                featurePaintList: [],
                fxlx: '',
                // 多选框
                checkAll: false,
                checkedCities: [],
                checkedValues: [],
                cities: cityOptions,
                isIndeterminate: true,
                dialogTableVisible: false,
                // 查询
                query: {
                    clzt: '',
                    khmc: '',
                    data_dt: []
                },
                addDataForm: [{}],
                getDataForm: [],
                // 分页
                pager: {
                    page: 1,
                    rows: 10,
                    total: 0
                }
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.getUserInfoAllList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.getUserInfoAllList();
            },
            handleCheckAllChange(val) {
                this.checkedCities = val ? cityOptions : [];
                this.isIndeterminate = false;
                this.fxlx = this.checkedCities.join('-');
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
                this.checkedValues = value;
                this.fxlx = value.join('-');
            },
            handleTypeChange(val) {
                this.addDataForm.param_type = val;
                this.$forceUpdate();
            },
            // 获取用户信息列表
            getUserInfoAllList() {
                let _this = this;
                util.publicget('/user/getUserInfoAllList', {
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows,
                    equalsUserName: _this.getDataForm.username,
                    equalsDepartment: _this.getDataForm.department == null ? _this.getDataForm.department: Base64.encode(_this.getDataForm.department)
                }, function (res) {
                    if (res.flag) {
                        _this.pager.total = res.count || 0;
                        _this.userInfoAllList = res.obj;
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 新增数据
            savaDataParams() {
                let _this = this;
                util.publicget('/user/savaDataParams', {
                    id: _this.addDataForm.id,
                    userName: _this.addDataForm.userName,
                    department: _this.addDataForm.department,
                    mobile: _this.addDataForm.mobile,
                    remark: _this.addDataForm.remark
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.getUserInfoAllList();
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
                // _this.dialogTableVisible = false;
            },
            // 更新字段信息
            updateModelDataParams(scopeRow) {
                let _this = this;
                _this.addDataForm.id = scopeRow.id;
                _this.addDataForm.userName = scopeRow.userName;
                _this.addDataForm.department = scopeRow.department;
                _this.addDataForm.mobile = scopeRow.mobile;
                _this.dialogTableVisible = true;
            },
            // 禁用用户
            deleteUser(id_val) {
                let _this = this;
                _this.$confirm('确认禁用吗?', '提示', {
                    // type: 'warning'
                }).then(() => {
                    util.publicget('/user/modifyUser', {
                        id: id_val,
                        enabled: '0'
                    }, function (res) {
                        if (res.flag) {
                            _this.successMsg('操作成功！');
                            // _this.dialogTableVisible = true;
                            _this.getUserInfoAllList();
                        } else {
                            _this.errorMsg('本次操作失败');
                        }
                    });
                }).catch(() => {
                });
            },
            // 启动用户
            modifyUser(id_val) {
                let _this = this;
                _this.$confirm('确认启用吗?', '提示', {
                    // type: 'warning'
                }).then(() => {
                    util.publicget('/user/modifyUser', {
                        id: id_val,
                        enabled: '1'
                    }, function (res) {
                        if (res.flag) {
                            _this.successMsg('操作成功！');
                            // _this.dialogTableVisible = true;
                            _this.getUserInfoAllList();
                        } else {
                            _this.errorMsg('本次操作失败');
                        }
                    });
                }).catch(() => {
                });
            },
            // 密码重置
            resetPassword(id_val) {
                let _this = this;
                _this.$confirm('确认重置密码吗?', '提示', {
                    // type: 'warning'
                }).then(() => {
                    util.publicget('/user/resetPassword', {
                        id: id_val
                    }, function (res) {
                        if (res.flag) {
                            _this.successMsg('操作成功！密码已重置！');
                            _this.getUserInfoAllList();
                        } else {
                            _this.errorMsg('本次操作失败');
                        }
                    });
                }).catch(() => {
                });
            },
            closeSava() {
                this.addDataForm = [{}];
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.data_dt), 'yyyy-MM-dd');
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            getControlTimeTo(val) {
                let date = new Date(val);
                let sipt = '-';
                let siptTo = ':';
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hours = date.getHours();
                let minutes = date.getMinutes();
                let seconds = date.getSeconds();
                let milliseconds = date.getMilliseconds();
                if (month >= 1 && month <= 9) {
                    month = '0' + month;
                }
                if (day >= 1 && day <= 9) {
                    day = '0' + day;
                }
                if (hours >= 0 && hours <= 9) {
                    hours = '0' + hours;
                }
                if (minutes >= 0 && minutes <= 9) {
                    minutes = '0' + minutes;
                }
                if (seconds >= 0 && seconds <= 9) {
                    seconds = '0' + seconds;
                }
                if (milliseconds >= 0 && milliseconds <= 9) {
                    milliseconds = '00' + milliseconds;
                }
                if (milliseconds >= 10 && milliseconds <= 99) {
                    milliseconds = '0' + milliseconds;
                }
                let currentdate = date.getFullYear() + sipt + month + sipt + day + 'T' + hours + siptTo + minutes + siptTo + seconds + '.' + milliseconds + 'Z';
                return currentdate;
            },
            // 时间确定按钮
            onChangeDate(val) {
                if (val) {
                    let that = this;
                    that.query.data_dt = [this.getControlTimeTo(val[0]), this.getControlTimeTo(val[1])];
                }
            }
        },
        mounted() {
            this.getUserInfoAllList();
        }
    };
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/pzxx/usermanage.vue